import { useContext, useEffect, useState } from 'react';
import { GlobalContext } from '@/shared/GlobalContext/GlobalContext';

export default function useEnrollmentFlow() {
  const context = useContext(GlobalContext);
  const [state, setState] = useState({
    loading: true,
    activeStep: 'checkEnrollmentCode',
    class: null,
    credentials: null,
    teacherName: null,
    studentData: null,
  });

  const actions = {
    setState: (newState) => {
      setState((previousState) => ({ ...previousState, ...newState }));
    },
    flowActions: {
      setClass: (clazz) => {
        if (
          clazz.subscription.teacher.firstName ||
          clazz.subscription.teacher.lastName
        ) {
          actions.setState({
            teacherName: `${clazz.subscription.teacher.firstName} ${clazz.subscription.teacher.lastName}`,
          });
        } else {
          actions.setState({ teacherName: clazz.subscription.teacher.email });
        }
        actions.setState({ class: clazz });
      },
      setActiveStep: (activeStep) => {
        actions.setState({ activeStep });
      },
      setCredentials: (credentials) => {
        actions.setState({ credentials });
      },
      setStudentData: (studentData) => {
        actions.setState({ studentData });
      },
    },
  };

  useEffect(() => {
    console.log('useEnrollmentFlow clearing session');
    context.actions.clearSession();
    actions.setState({ loading: false });
  }, []);

  return { state, actions };
}
